import React from 'react';
import { Building2 } from 'lucide-react';
import './Pricing.css';

const Pricing = () => {
  return (
    <section className="pricing section" id="pricing" data-testid="pricing-section">
      <div className="container">
        <div className="pricing-content">
          <div className="pricing-icon">
            <Building2 size={48} />
          </div>
          <h2 className="pricing-title">Enterprise Pricing</h2>
          <p className="pricing-description">
            Pricing depends on deployment scale and integrations.
          </p>
          <p className="pricing-cta-text">
            Request a demo to receive pricing details.
          </p>
          <a 
            href="mailto:contact@vantasignal.app?subject=VantaSignal Pricing Inquiry" 
            className="btn btn-primary"
            data-testid="pricing-request-demo"
          >
            Request Demo
          </a>
        </div>
      </div>
    </section>
  );
};

export default Pricing;
